class Autenticacao {
    constructor(id, dadosAutenticacao, nomeAutenticacao){
        this.id = id;
        this.dadosAutenticacao = dadosAutenticacao;
        this.nomeAutenticacao = nomeAutenticacao;
    }
}

export default Autenticacao;